export default "__VITE_ASSET__B7UZJ5v5__"